import React from 'react';
import './FooterRoutes.css';

const ShippingPolicy = () => {
  return (
    <div className="container">
      <h1 className="title">Shipping Policy</h1>
      <p>Thank you for choosing us for your eyewear needs. We are dedicated to providing you with a seamless shopping experience, including reliable and efficient shipping services. Please review our Shipping Policy to understand how we handle the delivery of your orders.</p>

      <div className="section">
        <h2 className="subtitle">Order Processing Time</h2>
        <ul>
          <li>Orders are typically processed within 1-2 business days after payment confirmation.</li>
          <li>Customized or prescription eyewear may require additional processing time.</li>
        </ul>
      </div>

      <div className="section">
        <h2 className="subtitle">Shipping Methods</h2>
        <p>We offer the following shipping methods for deliveries within India:</p>
        <ul>
          <li><span className="step-title">Standard Shipping:</span> Delivery Time: 3-7 business days after order processing. Shipping Fee: is upon us to deliver the product to you.</li>
          <li><span className="step-title">Express Shipping:</span> Delivery Time: 1-3 business days after order processing. Shipping Fee: is upon us to deliver the product to you.</li>
        </ul>
      </div>

      <div className="section">
        <h2 className="subtitle">Order Tracking</h2>
        <ul>
          <li>Once your order is shipped, you will receive a confirmation email with tracking information.</li>
          <li>You can track the status of your order through the provided tracking link.</li>
        </ul>
      </div>

      <div className="section">
        <h2 className="subtitle">Shipping Destinations</h2>
        <ul>
          <li>We currently offer shipping services across India, including rural and remote areas.</li>
          <li>For international shipping, please contact our customer support for assistance.</li>
        </ul>
      </div>

      <div className="section">
        <h2 className="subtitle">Delivery Partners</h2>
        <p>We partner with reputable courier services to ensure timely and secure deliveries. Our delivery partners may vary depending on your location and the selected shipping method.</p>
      </div>

      <div className="section">
        <h2 className="subtitle">Shipping Notifications</h2>
        <p>We will keep you informed about the status of your order through email notifications. In case of any delays or issues, our customer support team will reach out to you promptly.</p>
      </div>

      <div className="section">
        <h2 className="subtitle">Shipping Charges</h2>
        <p>Shipping charges are calculated based on the selected shipping method and delivery location. Any applicable shipping fees will be displayed during the checkout process.</p>
      </div>

      <div className="section">
        <h2 className="subtitle">Undeliverable Packages</h2>
        <p>If a package is deemed undeliverable due to an incorrect address or other issues, our customer support team will contact you with the available details to resolve the matter.</p>
      </div>

      <div className="section">
        <h2 className="subtitle">Shipping Delays</h2>
        <p>While we strive to deliver your orders within the specified timeframes, unforeseen circumstances such as natural disasters or public holidays may cause delays. We appreciate your understanding in such situations.</p>
      </div>

      <div className="section">
        <h2 className="subtitle">Returns Due to Non-Delivery</h2>
        <p>If a package is returned to us due to non-delivery, we will contact you to arrange re-shipment or issue a refund, excluding shipping charges.</p>
      </div>

      <div className="section">
        <h2 className="subtitle">Contact Us</h2>
        <p>If you have any questions or concerns about our Shipping Policy, please contact us at <a href="mailto:support@spectsgenie.com">support@spectsgenie.com</a>.</p>
      </div>

      <p>Thank you for choosing us. We appreciate your trust and are committed to delivering a positive shopping experience.</p>
    </div>
  );
};

export default ShippingPolicy;
